var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCoinx5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "39px",
    viewBox: "0 0 57.0 39.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,809 L0,809 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0109853,8.57489858 C36.7409237,16.7675238 33.9238821,27.2809372 25.731257,32.0109853 C17.538522,36.7410335 7.02521837,33.9239919 2.29517022,25.731257 C-2.43487793,17.538522 0.382163648,7.02521837 8.57489858,2.29517022 C16.7676335,-2.43487793 27.2809372,0.382163648 32.0109853,8.57489858 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9866026,0 C2.83785466,5.05528561 0.582048028,14.8490714 5.04448601,22.5782634 C9.50692399,30.3074553 19.116522,33.2507281 27.0688688,29.5874984 C26.6401217,29.8906728 26.1947999,30.1777116 25.731257,30.4453218 C17.5386318,35.1753699 7.02521837,32.3583283 2.29517022,24.1655934 C-2.43487793,15.9729682 0.382163648,5.45955479 8.57489858,0.729506637 C9.03844155,0.461896468 9.50966815,0.219642308 9.9866026,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98819856,1.87045594 C13.6648418,-1.98431597 22.2329773,0.311445593 26.0877493,6.98819856 C29.9425212,13.6648418 27.6467596,22.2329773 20.9700066,26.0877493 C14.2933634,29.9425212 5.72522785,27.6467596 1.87045594,20.9700066 C-1.98431597,14.2933634 0.311445593,5.72522785 6.98819856,1.87045594 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30350388,0 C2.59390152,4.14949434 0.817444193,12.0498119 4.42337596,18.295403 C8.02919797,24.540994 15.7592681,26.9526688 22.2075974,24.0827199 C21.8135365,24.3692098 21.4010349,24.6381372 20.9699827,24.8869773 C14.2933395,28.7417492 5.72520394,26.4459877 1.87043203,19.7692347 C-1.98433987,13.0924817 0.31153145,4.52445593 6.98817465,0.669684019 C7.41933656,0.420843883 7.85840165,0.198128119 8.30350388,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5931477,0 C19.5962431,2.58016597 22.0284441,4.1418107 26.2890219,4.1418107 L1.47855167,4.1418107 C0.665293369,4.1418107 0,3.47640757 0,2.66325903 L0,1.4784419 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0371815,0 C16.9838058,1.56043731 18.1724648,2.95809124 19.5501412,4.1418107 L1.47855167,4.1418107 C0.665293369,4.1418107 0,3.47640757 0,2.66325903 L0,1.4784419 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2664101,0 C11.6887907,1.4706485 12.3028232,2.86083832 13.0800782,4.14192047 L1.47855167,4.14192047 C0.665293369,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9058059,0 C7.95443236,1.43157171 8.17835555,2.8192369 8.55836639,4.14192047 L1.47855167,4.14192047 C0.665293369,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.930657,0 C13.637142,1.3883238 13.5240827,2.76336587 13.5709529,4.14192047 L1.47855167,4.14192047 C0.665293369,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4280665,0 C11.775067,1.29579083 11.2816676,2.68488299 10.9735536,4.1418107 L1.47855167,4.1418107 C0.665293369,4.1418107 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3507032,0 C14.183778,1.22279626 13.1959913,2.6178158 12.4279567,4.1418107 L1.47855167,4.1418107 C0.665293369,4.1418107 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4831357,0 C35.042285,0 35.5314036,0.314480366 35.7825488,0.775279172 C35.9954514,1.16588611 35.9676098,1.4573097 35.961831,2.25633543 L35.9616873,2.6633688 C35.9616873,2.77313507 35.9451126,2.90024441 35.9248059,2.98630117 C35.9026331,3.08465175 35.8704716,3.17905074 35.8297483,3.26905908 L35.7658012,3.39400905 C35.5104984,3.8395769 35.0308053,4.14192047 34.4831357,4.14192047 L1.48388207,4.14192047 C0.88642426,4.14192047 0.369864189,3.78210663 0.13726946,3.26905908 L0.082223696,3.12947515 C-0.0724494327,2.66923449 0.046542648,2.24661621 0.00533040262,1.47855167 C0.00533040262,0.665183602 0.670733538,0 1.48377231,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8020841,0 C16.4536347,0.921707378 14.3557818,2.34658334 12.6425498,4.14192047 L1.47855167,4.14192047 C0.665293369,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2679541,0 C6.45480557,0 5.7895122,0.665403135 5.7895122,1.47855167 L5.7895122,2.6633688 C5.7895122,3.47651734 6.45480557,4.1418107 7.2679541,4.14192047 L1.47855167,4.14192047 C0.665403135,4.14192047 0,3.4766271 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26806387,0 C6.45491533,0 5.7895122,0.665293369 5.7895122,1.4784419 L5.7895122,2.66325903 C5.7895122,3.47640757 6.45480557,4.14170094 7.2679541,4.14170094 L1.47855167,4.14170094 C0.665293369,4.14170094 0,3.47640757 0,2.66325903 L0,1.4784419 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2679541,0 C6.45480557,0 5.7895122,0.665403135 5.7895122,1.47855167 L5.7895122,2.6633688 C5.7895122,3.47651734 6.45480557,4.1418107 7.2679541,4.14192047 L1.47855167,4.14192047 C0.665403135,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26784434,0 C6.4546958,0 5.78940243,0.665403135 5.78940243,1.47855167 L5.78940243,2.6633688 C5.78940243,3.47651734 6.45480557,4.1418107 7.2679541,4.14192047 L1.47855167,4.14192047 C0.665403135,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26806387,0 C6.45491533,0 5.7895122,0.665403135 5.7895122,1.47855167 L5.7895122,2.6633688 C5.7895122,3.4766271 6.45480557,4.14192047 7.2679541,4.1418107 L1.47855167,4.1418107 C0.665293369,4.1418107 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2679541,0 C6.45480557,0 5.7895122,0.665293369 5.7895122,1.47855167 L5.7895122,2.66325903 C5.7895122,3.47651734 6.45480557,4.1418107 7.2679541,4.14192047 L1.47855167,4.14192047 C0.665403135,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2679541,0 C6.45480557,0 5.7895122,0.665403135 5.7895122,1.47855167 L5.7895122,2.6633688 C5.7895122,3.47651734 6.45480557,4.1418107 7.2679541,4.1418107 L1.47855167,4.1418107 C0.665403135,4.1418107 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27321415,0 C6.46006561,0 5.79466248,0.665293369 5.79466248,1.47855167 C5.83988618,2.32342266 5.69148218,2.75030369 5.92660154,3.26905908 L5.99054661,3.39400905 C6.24583539,3.8395769 6.72545302,4.14192047 7.27332392,4.14192047 L1.48392148,4.14192047 C0.88646367,4.14192047 0.369903599,3.78210663 0.137308871,3.26905908 L0.0822606321,3.12947515 C-0.0724281657,2.66923449 0.0464822707,2.24661621 0.00536981279,1.47855167 C0.00536981279,0.665183602 0.670772948,0 1.48381172,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26784434,0 C6.4546958,0 5.78940243,0.665293369 5.78940243,1.47855167 L5.78940243,2.6633688 C5.78940243,3.4766271 6.45480557,4.14192047 7.2679541,4.14192047 L1.47855167,4.14192047 C0.665403135,4.14192047 0,3.47651734 0,2.6633688 L0,1.47855167 C0,0.665293369 0.665403135,0 1.47855167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0109853,8.57489858 C36.7410335,16.767414 33.9239919,27.2808274 25.731257,32.0108756 C17.5386318,36.7409237 7.02521837,33.9238821 2.29517022,25.731257 C-2.43487793,17.538522 0.382163648,7.02521837 8.57489858,2.29517022 C16.7676335,-2.43487793 27.2809372,0.382163648 32.0109853,8.57489858 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9866026,0 C2.83785466,5.05528561 0.582048028,14.8490714 5.04448601,22.5782634 C9.50692399,30.3074553 19.116522,33.2507281 27.0688688,29.5873886 C26.6401217,29.890563 26.1947999,30.1776018 25.731257,30.445212 C17.5386318,35.1752601 7.02521837,32.3582186 2.29517022,24.1655934 C-2.43487793,15.9729682 0.382163648,5.45955479 8.57489858,0.729506637 C9.03844155,0.461896468 9.50966815,0.219642308 9.9866026,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98819856,1.87045594 C13.6649515,-1.98431597 22.2329773,0.311445593 26.0877493,6.98819856 C29.9425212,13.6648418 27.6467596,22.2329773 20.9700066,26.0877493 C14.2933634,29.9425212 5.72522785,27.6467596 1.87045594,20.9700066 C-1.98431597,14.2933634 0.311445593,5.72522785 6.98819856,1.87045594 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12947565,0.17009229 C8.93473282,0.620662249 10.2963671,2.19567222 10.4799694,4.03764985 C10.4869166,4.10414365 10.4750072,4.1716299 10.470045,4.26690461 L9.36843122,4.26690461 C9.33667298,4.11704544 9.30689964,3.97413338 9.27712629,3.83122132 C8.95656661,2.30583359 7.66936565,1.22803849 6.11321213,1.19429537 C5.53163945,1.18139359 4.94907433,1.18139359 4.36750165,1.19528781 C2.63667784,1.23895539 1.2016026,2.64822707 1.18572348,4.37905087 C1.16091236,7.06559907 1.15991991,9.75214726 1.18572348,12.4386955 C1.20259504,14.1496704 2.63965517,15.558942 4.3486452,15.605587 C4.90739164,15.6204736 5.46713054,15.6174963 6.02587698,15.6095567 C7.69219188,15.5867305 8.98832484,14.5009958 9.29399786,12.852545 C9.3436201,12.5865697 9.42797791,12.4764084 9.70387758,12.5022119 C9.9500039,12.5250382 10.1991076,12.5071741 10.4938637,12.5071741 C10.407521,13.7149795 9.97382257,14.6826132 9.1709347,15.4765691 C8.32140191,16.3181624 7.28925927,16.7578154 6.09634057,16.7697248 C5.32223359,16.7776643 4.53919461,16.7994981 3.77501208,16.7002536 C1.73156814,16.4362633 0.0662456934,14.6071874 0.0334950135,12.5438946 C-0.0111650045,9.78886772 -0.0111650045,7.03284839 0.0334950135,4.27881395 C0.0692230279,2.06268461 1.94990601,0.156198062 4.1650429,0.0500064637 C5.15153308,0.00236911113 6.15092503,-0.0740491419 7.12947565,0.17009229 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30350388,0 C2.59390152,4.14949434 0.817444193,12.0498119 4.42337596,18.295403 C8.02930773,24.540994 15.7593778,26.9526688 22.2075974,24.0827199 C21.8135365,24.3692098 21.4010349,24.6381372 20.9699827,24.8869773 C14.2933395,28.7417492 5.72520394,26.4459877 1.87043203,19.7692347 C-1.98433987,13.0924817 0.31153145,4.52445593 6.98817465,0.669684019 C7.41933656,0.420843883 7.85840165,0.198128119 8.30350388,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160.0 -430.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.0 103.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 267.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.0 60.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.894352223937858 3.458316688936975)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.33226763e-15,8.8817842e-16 34.3060829,8.8817842e-16 34.3060829,34.3061556 1.33226763e-15,34.3061556 1.33226763e-15,8.8817842e-16",
    stroke: "none",
    fill: "#FCD249"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.843487933027973 5.013772008137494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.050754524639051724 0.010318029475904211)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.77635684e-15,0 27.0688688,0 27.0688688,32.740492 -1.77635684e-15,32.740492 -1.77635684e-15,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.224784593929604 1.6185747500904153)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-8.8817842e-16,0 27.9582052,0 27.9582052,27.9582052 -8.8817842e-16,27.9582052 -8.8817842e-16,0",
    stroke: "none",
    fill: "#F9B938"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.0 7.342236597538431)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06829643634137028 0.4907723154829)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22.2075974,0 22.2075974,26.7574333 0,26.7574333 0,0",
    stroke: "none",
    fill: "#E59C1B"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294253 33.62599704362856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.2890219,0 26.2890219,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005378547280088242 29.48418633922165)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.5501412,0 19.5501412,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.96248188856498 25.34237563481474)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.0800782,0 13.0800782,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.670525560905845 21.20056493040829)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.55836639,0 8.55836639,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005378547280088242 17.058754226001376)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.930657,0 13.930657,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294255 12.91694352159448)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.4280665,0 12.4280665,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.40358862528728423)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294262 8.37154419190071)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.3507032,0 15.3507032,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.81446555475884e-05 0.08781301681619391)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.56125113e-17,0 35.966198,0 35.966198,4.14192047 1.56125113e-17,4.14192047 1.56125113e-17,0",
    stroke: "none",
    fill: "#F9B938"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.670525560905844 4.633322112781116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18.8020841,0 18.8020841,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294255 33.62599704362856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005378547280088242 29.48429610549283)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i15)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.26806387,0 7.26806387,4.14170094 0,4.14170094 0,0",
    stroke: "none",
    fill: "#D88D16"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294255 25.34237563481474)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i16)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.670525560905844 21.20056493040829)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i17)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#D88D16"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005378547280088242 17.0586444597302)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i18)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.26806387,0 7.26806387,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.962372122294255 12.91694352159448)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#D88D16"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.40358862528728423)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.9623721222942607 8.37154419190071)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i20)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.1418107 0,4.1418107 0,0",
    stroke: "none",
    fill: "#E59C1B"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0002282670338917825 0.0878130168161908)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i21)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.25514052e-17,0 7.27332392,0 7.27332392,4.14192047 -2.25514052e-17,4.14192047 -2.25514052e-17,0",
    stroke: "none",
    fill: "#E59C1B"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.670525560905844 4.633212346509936)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i22)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.2679541,0 7.2679541,4.14192047 0,4.14192047 0,0",
    stroke: "none",
    fill: "#D88D16"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.09837113300728 3.458426455208155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i23)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-4.4408921e-16 34.3061556,-4.4408921e-16 34.3061556,34.3060497 0,34.3060497 0,-4.4408921e-16",
    stroke: "none",
    fill: "#FCD249"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.074289812226198 5.013772008137494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.02408132078119607 0.010318029475882895)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i24)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.77635684e-15,0 27.0688688,0 27.0688688,32.7403861 1.77635684e-15,32.7403861 1.77635684e-15,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.156146179401995 1.661129568106313)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 27.9582052,0 27.9582052,27.9582052 0,27.9582052 0,0",
    stroke: "none",
    fill: "#F9B938"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.96013289036552 6.976744186046512)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.40859546e-15,-5.55111512e-17 10.4938637,-5.55111512e-17 10.4938637,16.7774086 -1.40859546e-15,16.7774086 -1.40859546e-15,-5.55111512e-17",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4938637,12.5101515 C10.407521,13.7149795 9.97382257,14.6826132 9.1709347,15.4765691 C8.32140191,16.3181624 7.28925927,16.7578154 6.09634057,16.7697248 C5.32223359,16.7776643 4.53919461,16.7994981 3.77501208,16.7002536 C1.73156814,16.4362633 0.0662456934,14.6071874 0.0334950135,12.5438946 C-0.0111650045,9.78886772 -0.0111650045,7.03284839 0.0334950135,4.27881395 C0.0692230279,2.06268461 1.94990601,0.156198062 4.1650429,0.0500064637 C5.15153308,0.00236911113 6.15092503,-0.0740491419 7.12947565,0.17009229 C8.93473282,0.620662249 10.2963671,2.19567222 10.4799694,4.03764985 C10.4869166,4.10414365 10.4750072,4.1716299 10.470045,4.26690461 C10.1028404,4.26690461 9.74556026,4.26690461 9.36843122,4.26690461 C9.33667298,4.11704544 9.30689964,3.97413338 9.27712629,3.83122132 C8.95656661,2.30583359 7.66936565,1.22803849 6.11321213,1.19429537 C5.53163945,1.18139359 4.94907433,1.18139359 4.36750165,1.19528781 C2.63667784,1.23895539 1.2016026,2.64822707 1.18572348,4.37905087 C1.16091236,7.06559907 1.15991991,9.75214726 1.18572348,12.4386955 C1.20259504,14.1496704 2.63965517,15.558942 4.3486452,15.605587 C4.90739164,15.6204736 5.46713054,15.6174963 6.02587698,15.6095567 C7.69219188,15.5867305 8.98832484,14.5009958 9.29399786,12.852545 C9.3436201,12.5865697 9.42797791,12.4764084 9.70387758,12.5022119 C9.9500039,12.5250382 10.1991076,12.5071741 10.4938637,12.5071741 L10.4938637,12.5101515 Z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.2723153454117 7.833008913021331)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i27)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22.2075974,0 22.2075974,26.7574333 0,26.7574333 0,0",
    stroke: "none",
    fill: "#E59C1B"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoinx5);
export default __webpack_public_path__ + "static/media/icCoinx5.3b43fcd355b4c4e03fbed71b046a22b6.svg";
export { ForwardRef as ReactComponent };